var map = {
	"./dc-arrow.jpg": 838,
	"./dc-batman.jpg": 680,
	"./dc-black.jpg": 872,
	"./dc-blue.jpg": 195,
	"./dc-flash.jpg": 401,
	"./dc-green.jpg": 974,
	"./dc-martian.jpg": 676,
	"./dc-robin.jpg": 590,
	"./dc-superman.jpg": 832,
	"./dc-wonder.jpg": 403,
	"./marvel-captain.jpg": 613,
	"./marvel-cyclops.jpg": 989,
	"./marvel-daredevil.jpg": 478,
	"./marvel-hawkeye.jpg": 573,
	"./marvel-hulk.jpg": 264,
	"./marvel-iron.jpg": 722,
	"./marvel-silver.jpg": 5,
	"./marvel-spider.jpg": 620,
	"./marvel-thor.jpg": 409,
	"./marvel-wolverine.jpg": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 263;